import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MARKETPLACEHEROBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "leading",
  "container_devided"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  marketplaceHeroBlockDescriptor: _generatedMarketplaceHeroBlockDescriptor,
  marketplaceHeroBlockBlocDefinition,
  marketplaceHeroBlockDashboardLayout,
  marketplaceHeroBlockConfig,
  marketplaceHeroBlockResolveConfig,
  marketplaceHeroBlockProperties,
} = doodBlockConfig(
  {
    name: "Marketplace hero",
    componentType: 'MarketplaceHeroBlockComponent',
    category: 'content',
    description: "Marketplace hero.",
    keywords: [],
    allowedIn: [
      { bloc: 'GenericPageComponent', slot: '*' },
    ],

    sharedFields: {}
,
    slots: [
      {
        key: 'image_slides',
        name: 'pages.blocks.marketplace-hero.image-slides.label',
        accept: 'explicitOnly',
        allowedTypes: ["MarketplaceHeroSlideImageBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'text_slides',
        name: 'pages.blocks.marketplace-hero.text-slides.label',
        accept: 'explicitOnly',
        allowedTypes: ["MarketplaceHeroSlideTextBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.marketplace-hero.heading.label",
        help: "pages.blocks.marketplace-hero.heading.help",
        placeholder: "",
      }
    }),
    leading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.marketplace-hero.leading.label",
        placeholder: "",
      }
    }),
    container_devided: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.marketplace-hero.container-devided.label",
        help: "pages.blocks.marketplace-hero.container-devided.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.marketplace-hero.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.marketplace-hero.fieldset.title.label",
            fields: ["heading"],
          },
          {
            legend: "pages.blocks.marketplace-hero.fieldset.leading.label",
            fields: ["leading"],
          },
          {
            legend: "pages.blocks.marketplace-hero.fieldset.layout.label",
            fields: ["container_devided"],
          },
          {
            legend: "pages.blocks.marketplace-hero.fieldset.image-slides.label",
            fields: ["image_slides"],
          },
          {
            legend: "pages.blocks.marketplace-hero.fieldset.text-slides.label",
            fields: ["text_slides"],
          },
        ],
      },
    ],
  })
);

export function marketplaceHeroBlockDescriptor(): IBlockDescriptor;
export function marketplaceHeroBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function marketplaceHeroBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMarketplaceHeroBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMarketplaceHeroBlockDescriptor, marketplaceHeroBlockProperties, fieldOrder);
}

export {
  marketplaceHeroBlockBlocDefinition,
  marketplaceHeroBlockDashboardLayout,
  marketplaceHeroBlockProperties,
  marketplaceHeroBlockConfig,
  marketplaceHeroBlockResolveConfig,
};

export type MarketplaceHeroBlockConfig = typeof marketplaceHeroBlockConfig;
